import { render, staticRenderFns } from "./TheVerifyMessageLayout.vue?vue&type=template&id=e0fd6e74"
import script from "./TheVerifyMessageLayout.vue?vue&type=script&lang=js"
export * from "./TheVerifyMessageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports